/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { MetaInfoFile } from '../models';
/**
 * MetainfofileApi - axios parameter creator
 * @export
 */
export const MetainfofileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete the MetaInfoFile by ID
         * @param {number} id 
         * @param {'repairExtension' | 'workingimages'} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metainfofileIdDelete: async (id: number, context: 'repairExtension' | 'workingimages', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('metainfofileIdDelete', 'id', id)
            // verify required parameter 'context' is not null or undefined
            assertParamExists('metainfofileIdDelete', 'context', context)
            const localVarPath = `/metainfofile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the MetaInfoFile by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metainfofileIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('metainfofileIdGet', 'id', id)
            const localVarPath = `/metainfofile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload an image in tmp folder and get resized base64Content and meta data
         * @param {MetaInfoFile} metaInfoFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metainfofileTmpimageuploadPost: async (metaInfoFile: MetaInfoFile, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metaInfoFile' is not null or undefined
            assertParamExists('metainfofileTmpimageuploadPost', 'metaInfoFile', metaInfoFile)
            const localVarPath = `/metainfofile/tmpimageupload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metaInfoFile, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetainfofileApi - functional programming interface
 * @export
 */
export const MetainfofileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetainfofileApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete the MetaInfoFile by ID
         * @param {number} id 
         * @param {'repairExtension' | 'workingimages'} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metainfofileIdDelete(id: number, context: 'repairExtension' | 'workingimages', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metainfofileIdDelete(id, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the MetaInfoFile by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metainfofileIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaInfoFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metainfofileIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload an image in tmp folder and get resized base64Content and meta data
         * @param {MetaInfoFile} metaInfoFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metainfofileTmpimageuploadPost(metaInfoFile: MetaInfoFile, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaInfoFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metainfofileTmpimageuploadPost(metaInfoFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MetainfofileApi - factory interface
 * @export
 */
export const MetainfofileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetainfofileApiFp(configuration)
    return {
        /**
         * Delete the MetaInfoFile by ID
         * @param {number} id 
         * @param {'repairExtension' | 'workingimages'} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metainfofileIdDelete(id: number, context: 'repairExtension' | 'workingimages', options?: any): AxiosPromise<void> {
            return localVarFp.metainfofileIdDelete(id, context, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the MetaInfoFile by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metainfofileIdGet(id: number, options?: any): AxiosPromise<MetaInfoFile> {
            return localVarFp.metainfofileIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload an image in tmp folder and get resized base64Content and meta data
         * @param {MetaInfoFile} metaInfoFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metainfofileTmpimageuploadPost(metaInfoFile: MetaInfoFile, options?: any): AxiosPromise<MetaInfoFile> {
            return localVarFp.metainfofileTmpimageuploadPost(metaInfoFile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetainfofileApi - object-oriented interface
 * @export
 * @class MetainfofileApi
 * @extends {BaseAPI}
 */
export class MetainfofileApi extends BaseAPI {
    /**
     * Delete the MetaInfoFile by ID
     * @param {number} id 
     * @param {'repairExtension' | 'workingimages'} context 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetainfofileApi
     */
    public metainfofileIdDelete(id: number, context: 'repairExtension' | 'workingimages', options?: AxiosRequestConfig) {
        return MetainfofileApiFp(this.configuration).metainfofileIdDelete(id, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the MetaInfoFile by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetainfofileApi
     */
    public metainfofileIdGet(id: number, options?: AxiosRequestConfig) {
        return MetainfofileApiFp(this.configuration).metainfofileIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload an image in tmp folder and get resized base64Content and meta data
     * @param {MetaInfoFile} metaInfoFile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetainfofileApi
     */
    public metainfofileTmpimageuploadPost(metaInfoFile: MetaInfoFile, options?: AxiosRequestConfig) {
        return MetainfofileApiFp(this.configuration).metainfofileTmpimageuploadPost(metaInfoFile, options).then((request) => request(this.axios, this.basePath));
    }
}
